module.exports = __webpack_public_path__ + "img/xczcfwImg.15e5bbd8.png";